<div class="title_div">
    <div class="w-100 d-flex justify-content-between align-items-center">
        <div class="title_sub_div_1 mt-1">Part Sync</div>
        <div class="title_sub_div_1 title_right_icon_div mr-1">
            <i class="fa fa-home mr-2" (click)="home()" title="Dashboard"></i>
            <i class="fa fa-arrow-left" (click)="back()" title="Go to Smart Sync page"></i>
        </div>
    </div>
</div>

<div class="col-12 grid-margin stretch-card col_pad">
    <div class="card">
        <div class="card-body">
            <div class="table-responsive gd_main_div_mobile">
                <table class="table table-striped custom-hover">
                    <thead>
                        <tr>
                            <th (click)="sortData('MPN', 1)">
                                MPN
                                <i [ngClass]="getSortIcon('MPN', 1)"></i>
                            </th>
                            <th (click)="sortData('internalPartNo',1)">
                                IPN
                                <i [ngClass]="getSortIcon('internalPartNo',1)"></i>
                            </th>
                            <th (click)="sortData('manufacturer',1)">
                                Make
                                <i [ngClass]="getSortIcon('manufacturer',1)"></i>
                            </th>
                            <th (click)="sortData('uom',1)">
                                UOM
                                <i [ngClass]="getSortIcon('uom',1)"></i>
                            </th>
                            <th (click)="sortData('quantity',1)">
                                Quantity
                                <i [ngClass]="getSortIcon('quantity',1)"></i>
                            </th>
                            <th *ngIf="userRole === 'Manager'">Engineer Name</th>
                            <th (click)="sortData('projectName',1)">
                                Project Name
                                <i [ngClass]="getSortIcon('projectName',1)"></i>
                            </th>
                            <th (click)="sortData('supplier',1)">
                                Supplier
                                <i [ngClass]="getSortIcon('supplier',1)"></i>
                            </th>
                            <th (click)="sortData('Inventorylevel',1)">
                                Stock
                                <i [ngClass]="getSortIcon('Inventorylevel',1)"></i>
                            </th>
                            <th (click)="sortData('Price',1)">
                                Price
                                <i [ngClass]="getSortIcon('Price',1)"></i>
                            </th>
                            <th (click)="sortData('Currency',1)">
                                Currency
                                <i [ngClass]="getSortIcon('Currency',1)"></i>
                            </th>
                            <th (click)="sortData('Closest_Quantity',1)">
                                MOQ
                                <i [ngClass]="getSortIcon('Closest_Quantity',1)"></i>
                            </th>
                            <th (click)="sortData('estimatedFactoryLeadDays',1)">
                                Lead Time
                                <i [ngClass]="getSortIcon('estimatedFactoryLeadDays',1)"></i>
                            </th>
                            <th (click)="sortData('ConvertedPrice',1)">
                                Price in INR
                                <i [ngClass]="getSortIcon('ConvertedPrice',1)"></i>
                            </th>
                            <th (click)="sortData('variance',1)">
                                Total Price(INR)
                                <i [ngClass]="getSortIcon('variance',1)"></i>
                            </th>

                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let row of sourceListData, let i = index">
                            <td>{{ row?.MPN }}</td>
                            <td>{{ row?.internalPartNo }}</td>
                            <td>{{ row?.manufacturer }}</td>
                            <td>{{ row?.uom }}</td>
                            <td>{{ row?.projectQty }}</td>
                             <td *ngIf="userRole === 'Manager'" title="{{ row?.engineer_name }}">{{
                                                row?.engineer_name }}
                                            </td>
                            <td>{{ row?.projectName }}</td>
                            <td>{{ row?.supplier }}</td>
                            <td>{{ row?.Inventorylevel }}</td>
                            <td>{{ row?.Price }}</td>
                            <td>{{ row?.Currency }}</td>
                            <td>{{ row?.Closest_Quantity}}</td>
                            <td>{{ row?.estimatedFactoryLeadDays }}</td>
                            <td>{{ row?.ConvertedPrice }}</td>
                            <td>{{ row?.variance | number:'1.2-2' }}</td>

                        </tr>
                    </tbody>


                </table>
            </div>
        </div>
    </div>
</div>
<!-- Only display 'GrossProjectQuantity' -->
<div class="custom-name">
    <div class="form-group card" title="{{GrossprojectQty}}">
        <div class="custom-card-small custom-card-open-projects ">
            <div class="custom-card-content-small">
                <div class="custom-card-text-small"><b> Gross Quantity :</b></div>
                <div class="custom-card-text-small">{{GrossprojectQty}}</div>
            </div>
        </div>
    </div>
    <div class="form-group card" title="{{ totalSum | number:'1.2-2' }}">
        <div class="custom-card-small custom-card-open-projects ">
            <div class="custom-card-content-small">
                <div class="custom-card-text-small"><b>Gross Value :</b></div>
                <div class="custom-card-text-small">{{ totalSum | number:'1.2-2' }}</div>
            </div>
        </div>
    </div>

    <div class="form-group card" title="{{ grossPrice | number:'1.2-2' }}">
        <div class="custom-card-small custom-card-open-projects">
            <div class="custom-card-content-small">
                <div class="custom-card-text-small">
                    <b>Cost Saving: </b>
                </div>
                <div class="custom-card-text-diff" [ngStyle]="{'color': grossPrice >= 0 ? 'green' : 'red'}">
                    {{ grossPrice | number:'1.2-2' }}
                </div>
            </div>
        </div>
    </div>

</div>


<div class="d-flex justify-content-between">
    <button type="button" class="btn btn-outline-primary btn-sm" title="Get Live Price" (click)="openPopup()">Get
        Live Price</button>
</div>

<div class="row row_mar mt-1">
    <div class="col-12 grid-margin stretch-card col_pad">
        <div class="card">
            <div class="card-body" *ngIf="isTableEnabled">
                <div class="table-responsive gd_main_div_mobile">
                    <table class="table table-bordered table-striped custom-hover">
                        <thead>
                            <tr>
                                <th (click)="sortData('supplier',2)">
                                    Supplier
                                    <i [ngClass]="getSortIcon('supplier',2)"></i>
                                </th>
                                <th (click)="sortData('manufacturer',2)">
                                    Make
                                    <i [ngClass]="getSortIcon('manufacturer',2)"></i>
                                </th>
                                <th (click)="sortData('Inventorylevel',2)">
                                    Stock
                                    <i [ngClass]="getSortIcon('Inventorylevel',2)"></i>
                                </th>
                                <th (click)="sortData('uom',2)">
                                    UOM
                                    <i [ngClass]="getSortIcon('uom',2)"></i>
                                </th>
                                <th (click)="sortData('Price',2)">
                                    Price
                                    <i [ngClass]="getSortIcon('Price',2)"></i>
                                </th>
                                <th (click)="sortData('Currency',2)">
                                    Currency
                                    <i [ngClass]="getSortIcon('Currency',2)"></i>
                                </th>
                                 <!-- <th (click)="sortData('Price_INR',2)">
                                    Converted Price
                                    <i [ngClass]="getSortIcon('Price_INR',2)"></i>
                                </th>
                                 <th (click)="sortData('Landing_Cost_INR',2)">
                                   Landing Cost
                                    <i [ngClass]="getSortIcon('Landing_Cost_INR',2)"></i>
                                </th> -->
                                <th (click)="sortData('Closest_Quantity',2)">
                                    MOQ
                                    <i [ngClass]="getSortIcon('Closest_Quantity',2)"></i>
                                </th>
                                <th (click)="sortData('estimatedFactoryLeadDays',2)">
                                    Lead Time
                                    <i [ngClass]="getSortIcon('estimatedFactoryLeadDays',2)"></i>
                                </th>
                                <th (click)="sortData('variance',2)">
                                    Total Price(INR)
                                    <i [ngClass]="getSortIcon('variance',2)"></i>
                                </th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let row of finalConvertedData, let i = index"
                                [class.selected]="selectedPriceRowIndex === i">
                                <!-- <td>{{ row?.supplier }}</td> -->
                                <td title="{{ row?.supplier }}">
                                    <ng-container *ngIf="row?.clickUrl; else noLink">
                                        <a [href]="row.clickUrl" target="_blank" rel="noopener noreferrer">
                                            {{ row?.supplier }}
                                        </a>
                                    </ng-container>
                                    <ng-template #noLink>
                                        {{ row?.supplier }}
                                    </ng-template>
                                </td>
                                <td>{{ row?.manufacturer }}</td>
                                <td>{{ row?.Inventorylevel }}</td>
                                <td>{{ row?.uom }}</td>
                                <td>{{ row?.Price | number:'1.2-2'}}</td>
                                <td>{{ row?.Currency }}</td>
                                <!-- <td>{{ row?.Price_INR | number:'1.2-2' }}</td>
                                <td>{{ row?.Landing_Cost_INR | number:'1.2-2' }}</td> -->
                                <td>{{ row?.Closest_Quantity}}</td>
                                <td>{{ row?.estimatedFactoryLeadDays}}</td>
                                <td>{{ row?.variance | number:'1.2-2' }}</td>
                                <td>
                                    <input type="checkbox" [checked]="selectedPriceRowIndex === i"
                                        (change)="selectPriceRow(i,row)" />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="d-flex justify-content-end">
    <button *ngIf="isTableEnabled" type="button" class="btn btn-outline-primary btn-sm" title="Conform and Apply"
        [disabled]="!isConfirmEnabled" (click)="onConfirm()">Confirm and Apply
    </button>
</div>
<div class="modal fade" id="confirmModal" tabindex="-1" aria-labelledby="confirmModalLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="confirmModalLabel">Confirm and Apply</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                Are you sure you want to Confirm and Apply?
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                <button type="button" class="btn btn-primary" (click)="onSave()">Save</button>
            </div>
        </div>
    </div>
</div>